/* SNZ REVIEW VOTES (20 Oct 2026) — "Was this helpful?" thumbs on snoozyn's own reviews.
   Markup: snippets/snz-review-vote.liquid. ONE score shows between the thumbs: helpful_up minus
   helpful_down. Thumbs up raises it by 1, thumbs down lowers it by 1. A click is POSTed to
   /apps/snz-votes (Shopify app proxy -> snz-votes Cloudflare Worker), which updates the two fields
   and returns the new shared counts. One vote per review per browser (remembered in localStorage);
   clicking the same thumb again takes the vote back, clicking the other thumb moves it (a move
   shifts the score by 2). Injects its own CSS, so no stylesheet edit is needed. */
(function () {
  if (window.__snzVotes) return;
  window.__snzVotes = 1;

  var ENDPOINT = '/apps/snz-votes';
  var KEY = 'snzv:';

  var css =
    '.snzv{display:flex;align-items:center;flex-wrap:wrap;gap:.8rem;margin-top:1.4rem;font-family:Montserrat,sans-serif;font-size:1.2rem;color:#4A4F54}' +
    '.snzv__q{letter-spacing:.04em;margin-right:.2rem}' +
    '.snzv__b{display:inline-flex;align-items:center;justify-content:center;min-height:3.6rem;min-width:4.4rem;margin:0;padding:0 1.2rem;border:1px solid #D6D2CA;border-radius:0;background:transparent;color:#2A2C2E;font:inherit;cursor:pointer;transition:border-color .2s ease,background-color .2s ease,color .2s ease;-webkit-tap-highlight-color:transparent}' +
    '.snzv__b svg{display:block;flex:0 0 auto}' +
    '.snzv__b--dn svg{transform:rotate(180deg)}' +
    '.snzv__b:focus-visible{outline:2px solid #3B3F43;outline-offset:2px}' +
    '.snzv__b[aria-pressed="true"]{border-color:#3B3F43;background:#3B3F43;color:#fff}' +
    '.snzv__b[aria-busy="true"]{opacity:.6;cursor:progress}' +
    '.snzv__s{min-width:2.4rem;text-align:center;font-size:1.3rem;font-weight:600;color:#2A2C2E;font-variant-numeric:tabular-nums}' +
    '.snzv__msg{flex-basis:100%;font-size:1.1rem;color:#4A4F54}' +
    '.snzv__msg:empty{display:none}' +
    '@media (hover:hover) and (pointer:fine){.snzv__b:not([aria-pressed="true"]):hover{border-color:#3B3F43}}' +
    '@media (prefers-reduced-motion:reduce){.snzv__b{transition:none}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function getVote(id) {
    try { return localStorage.getItem(KEY + id); } catch (e) { return null; }
  }
  function setVote(id, v) {
    try {
      if (v) localStorage.setItem(KEY + id, v);
      else localStorage.removeItem(KEY + id);
    } catch (e) {}
  }
  function btn(row, dir) { return row.querySelector('.snzv__b[data-v="' + dir + '"]'); }
  function get(row, dir) { return Math.max(0, parseInt(row.getAttribute('data-' + dir), 10) || 0); }
  function show(row, up, down) {
    up = Math.max(0, parseInt(up, 10) || 0);
    down = Math.max(0, parseInt(down, 10) || 0);
    row.setAttribute('data-up', up);
    row.setAttribute('data-down', down);
    var s = up - down;
    var el = row.querySelector('[data-s]');
    if (!el) return;
    el.textContent = s < 0 ? '−' + Math.abs(s) : String(s);
    el.setAttribute('aria-label', 'Helpful score ' + s);
  }
  function paint(row, vote) {
    ['up', 'down'].forEach(function (d) { btn(row, d).setAttribute('aria-pressed', vote === d ? 'true' : 'false'); });
  }
  function busy(row, on) {
    ['up', 'down'].forEach(function (d) {
      var b = btn(row, d);
      if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    });
  }
  function say(row, text) {
    var m = row.querySelector('.snzv__msg');
    if (m) m.textContent = text || '';
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-snzv]').forEach(function (row) {
      if (row.dataset.snzvReady) return;
      row.dataset.snzvReady = '1';
      paint(row, getVote(row.getAttribute('data-snzv')));
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.snzv__b');
    if (!b) return;
    var row = b.closest('[data-snzv]');
    if (!row || row.dataset.snzvBusy) return;
    e.preventDefault();

    var id = row.getAttribute('data-snzv');
    var dir = b.getAttribute('data-v');
    var prev = getVote(id);
    var next = prev === dir ? null : dir;
    var before = { up: get(row, 'up'), down: get(row, 'down') };
    var after = { up: before.up, down: before.down };
    if (prev) after[prev] -= 1;
    if (next) after[next] += 1;

    // Show the change straight away; the server's numbers replace it when they arrive.
    show(row, after.up, after.down);
    paint(row, next);
    say(row, '');
    row.dataset.snzvBusy = '1';
    busy(row, true);

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, prev: prev, next: next })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || !j || j.ok !== true) throw new Error((j && j.error) || 'HTTP ' + r.status);
          return j;
        });
      })
      .then(function (j) {
        setVote(id, next);
        show(row, j.up, j.down);
        say(row, next ? 'Thanks for your feedback.' : '');
      })
      .catch(function () {
        show(row, before.up, before.down);
        paint(row, prev);
        say(row, 'Sorry, your vote could not be saved. Please try again later.');
      })
      .then(function () {
        delete row.dataset.snzvBusy;
        busy(row, false);
      });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
